import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { trackAnalytics } from "@/lib/analytics";
import { loadSizes } from "@/lib/pricing";
import type { LoadSize } from "@/types/booking";
import type { StepProps } from "@/components/booking/steps/types";
import { StepFrame } from "@/components/booking/steps/StepFrame";

export function ManVanStep({ state, isLocked, updateState, goNext, goBack }: StepProps) {
  function selectLoadSize(loadSize: LoadSize) {
    updateState({ loadSize });
    trackAnalytics("load size selected", { loadSize });
    goNext();
  }

  return (
    <StepFrame title="Estimate load size" description="This placeholder step captures the core man-and-van option before detailed API pricing is connected." canBack onBack={goBack} hideNext isReadOnly={isLocked}>
      <RadioGroup className="grid gap-3 md:grid-cols-2">
        {loadSizes.map((load) => (
          <Label key={load.id} className="flex cursor-pointer gap-3 rounded-lg border-2 border-accent/10 bg-white p-4">
            <RadioGroupItem
              name="loadSize"
              checked={state.loadSize === load.id}
              onChange={() => selectLoadSize(load.id)}
              readOnly={isLocked}
              disabled={isLocked}
            />
            <span>
              <span className="block font-black">{load.title}</span>
              <span className="text-sm text-muted-foreground">{load.description}</span>
            </span>
          </Label>
        ))}
      </RadioGroup>
    </StepFrame>
  );
}
